import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { TermRoutesAPI } from '../constants';

export interface Term extends Record<string, any>{
  id: number;
  termId: number;
  content: string;
}

export enum TermType {
  TERM_OF_USE = 'TERM_OF_USE',
  PRIVACY_NOTICE = 'PRIVACY_NOTICE',
}

@Injectable({})
export class TermService {

  static isRead(type: TermType): Promise<boolean> {
    return HttpService.get(TermRoutesAPI.TERM_IS_READ, { type })
      .then(response => {
        return response.body as boolean;
      });
  }

  static updateRead(type: TermType, id: number | string): Promise<boolean> {
    return HttpService.put(TermRoutesAPI.TERM_READ, { type, id })
      .then(response => {
        return response.status === 204;
      });
  }

}
